// Kept in step with the other runtime by passwordPolicy.test.js.
export const MIN_PASSWORD_LENGTH = 12;

export function validateNewPassword(value) {
  if (!value.trim()) return "Password is required";
  if (value.length < MIN_PASSWORD_LENGTH) return "Password must be at least 12 characters long";
  if (!/[a-z]/.test(value)) return "Password must contain at least one lowercase letter";
  if (!/[A-Z]/.test(value)) return "Password must contain at least one uppercase letter";
  if (!/\d/.test(value)) return "Password must contain at least one number";
  if (!/[!@#$%^&*(),.?":{}|<>]/.test(value)) return "Password must contain at least one special character";
  return "";
}
